/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PraetorBreakdown = zod
	.object({
		praetor_id: zod.string().describe('Praetor ID'),
		total_cases: zod.number().describe('Cases processed by this praetor'),
		violations: zod.number().describe('Violations detected by this praetor')
	})
	.describe('Per-praetor case breakdown');

export type PraetorBreakdown = zod.input<typeof PraetorBreakdown>;
export type PraetorBreakdownOutput = zod.output<typeof PraetorBreakdown>;
